<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="column column-left">
        <router-link to="/" class="logo">
          <img src="./../assets/img/logo.svg" alt="logo" />
          <span class="desc">GETCRUSHSKIN</span>
        </router-link>

        <!-- Copyright Notice -->
        <div v-if="footerCopyright" class="copyright">
          {{ footerCopyright }}
        </div>
        <div class="list">
          <a
            v-for="link in socials"
            :key="link.image"
            :href="link.link"
            target="_blank"
            class="social-link item"
          >
            <img :src="link.img" class="img" />
          </a>
        </div>
      </div>
      <div class="column column-left">
        <div class="link-columns">
          <div class="link-column">
            <router-link :to="{ name: 'ProductListPage' }" class="footer-link">
              {{ $t(`Buy skins`) }}
            </router-link>
            <a class="footer-link" @click="sellSkin">
              {{ $t("Sell skin") }}
            </a>
            <!-- <router-link :to="{ name: 'ContactUsPage' }" class="footer-link">
              {{ $t(`Contact Us`) }}
            </router-link>
            <router-link :to="{ name: 'SupportPage' }" class="footer-link">
              {{ $t(`FAQ`) }}
            </router-link> -->
          </div>
        </div>
      </div>
      <div class="column column-left">
        <div class="link-column">
          <router-link
            v-for="page in staticPages"
            :key="page.id"
            :to="`/pages/${page.id}`"
            class="footer-link"
          >
            <span>{{ page.title }}</span>
          </router-link>
        </div>
      </div>
      <div class="column column-right">
        <div class="company-info">
          {{ footerRequisites }}<br />
          {{ footerSupportEmail }}
        </div>
      </div>
      <div class="column column-right">
        <ul class="methods">
          <li class="item">
            <img
              src="@/assets/img/mastercard.svg"
              class="img"
              style="height: 30px"
            />
          </li>
          <li class="item">
            <img src="@/assets/img/visa.png" class="img" style="height: 16px" />
          </li>
          <!-- <li class="item">
            <img
              src="@/assets/img/apple_pay.svg"
              class="img"
              style="height: 27px"
            />
          </li>
          <li class="item">
            <img src="@/assets/img/gpay.png" class="img" style="height: 28px" />
          </li> -->
        </ul>
        <div v-if="paymentMethodsList.length" class="payment-methods">
          <div
            v-for="method in paymentMethodsList"
            :key="method.code"
            class="payment-method"
          >
            <img :src="method.image" :alt="method.title" class="payment-logo" />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
import {
  TERMS_PAGE,
  PRIVACY_PAGE,
  COOKIE_PAGE,
} from "@/store/modules/staticPages";

export default {
  name: "FooterComponent",
  props: {
    footerRequisites: {
      type: String,
    },
    footerSupportEmail: {
      type: String,
      required: true,
    },
    footerCopyright: {
      type: String,
      default: "",
    },
    paymentMethods: {
      type: [Object, Array],
    },
    isAuth: {
      type: Boolean,
    },
  },
  data() {
    return {
      socials: [],
    };
  },
  computed: {
    ...mapState("staticPages", ["pages"]),
    staticPages() {
      return this.pages || [];
    },
    paymentMethodsList() {
      if (!this.paymentMethods) return [];
      return this.paymentMethods.filter((method) => method && method.image);
    },
    allImages() {
      return this.paymentMethodsList.flatMap(this.getImages);
    },
  },
  created() {
    // Make constants available in template
    this.TERMS_PAGE = TERMS_PAGE;
    this.PRIVACY_PAGE = PRIVACY_PAGE;
    this.COOKIE_PAGE = COOKIE_PAGE;
  },
  mounted() {
    this.getSocials();
  },
  methods: {
    sellSkin() {
      if (this.isAuth) {
        this.$emit("openSellSkinModal");
      } else {
        this.$emit("openSignIn");
      }
    },
    handleShopNowClick() {
      if (this.isAuth) {
        this.$router.push("/products/all");
      } else {
        this.$emit("openSignIn");
      }
    },
    getPageType(page) {
      if (page.is_terms === 1) return TERMS_PAGE;
      if (page.is_privacy === 1) return PRIVACY_PAGE;
      if (page.is_cookie === 1) return COOKIE_PAGE;
      return null;
    },
    getImages(method) {
      const images = [];
      if (method.code === "card" || method.title === "Visa/Mastercard") {
        images.push(
          require("@/assets/img/methods/visa.svg"),
          require("@/assets/img/methods/mc_symbol.svg"),
        );
      } else if (method.code === "eps" || method.title === "EPS") {
        images.push(require("@/assets/img/methods/eps.svg"));
      } else if (method.code === "trustly" || method.title === "Trustly") {
        images.push(require("@/assets/img/methods/trustly.svg"));
      } else if (method.code === "giropay" || method.title === "GiroPay") {
        images.push(require("@/assets/img/methods/giropay.svg"));
      } else if (method.code === "blik" || method.title === "Blik") {
        images.push(require("@/assets/img/methods/blik.svg"));
      } else if (method.code === "paidby" || method.title === "Paidby") {
        images.push(require("@/assets/img/methods/paidby.svg"));
      } else if (method.code === "klarna" || method.title === "Klarna") {
        images.push(require("@/assets/img/methods/klarna.svg"));
      } else if (
        method.code === "sofortuberweisung" ||
        method.title === "Sofortuberweisung"
      ) {
        images.push(require("@/assets/img/methods/sofortuber.svg"));
      } else if (method.code === "ideal" || method.title === "iDEAL") {
        images.push(require("@/assets/img/methods/ideal.svg"));
      } else if (
        method.code === "bancontact" ||
        method.title === "Bancontact"
      ) {
        images.push(require("@/assets/img/methods/bancontact.svg"));
      }
      return images;
    },
    getSocials() {
      this.$http
        .get(process.env.VUE_APP_API + "social-links")
        .then((res) => {
          this.socials = res.data.payload;
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.logo {
  gap: 10px;
  display: flex;
  align-items: center;
}
.logo img {
  display: block;
  width: 36px;
}
.logo .desc {
  font-weight: 700;
}
.footer {
  position: relative;
  padding: 0 16px;

  .methods {
    align-items: flex-end;
    display: flex;
    gap: 12px;

    .item {
      height: 32px;
      display: flex;
      align-items: center;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 15px;

    .methods {
      justify-content: center;
    }
  }
  .column-left {
    max-width: 240px;
  }
}

.footer-content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0 auto;
  padding: 100px 0 15px;
  max-width: 1420px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
}
.footer-content + .footer-content {
  padding: 16px 0;

  .footer-link {
    font-size: 14px;
  }
}

.column {
  flex: 1;
  text-align: left;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
}

.site-name {
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
}

.company-info {
  color: #ffffff99;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 150%;
}

.column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: 768px) {
    order: -1;
  }
}

.ready-text {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  color: #15ca5c;
  margin-bottom: 16px;
}

.column-right {
  display: flex;
  justify-content: flex-end;
  max-width: 340px;

  @media (max-width: 768px) {
    justify-content: center;
  }
}
.column-right:last-child {
  max-width: 200px;
}

.link-columns {
  width: 100%;
  max-width: 350px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}

.link-column {
  @media (max-width: 768px) {
    align-items: center;
  }
}

.footer-link {
  color: white;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  display: table;
  text-decoration: none;
}
.footer-link + .footer-link {
  margin-top: 14px;
}

.payment-methods {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 20px;
  margin-top: 18px;

  @media (max-width: 768px) {
    justify-content: center;
  }
}

.payment-method {
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-logo {
  max-height: 30px;
  max-width: 100px;
  object-fit: contain;
}

.list {
  display: flex;
  justify-content: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-top: 10px;
  }

  .item {
    margin: 0 10px;

    .img {
      width: 30px;
      height: 30px;
    }
  }
}

.copyright {
  color: white;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-top: 10px;
    font-size: 10px;
  }
}

.trademark-disclaimer {
  color: #a1a2a9;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  text-align: center;
  margin-top: 15px;
  //padding-bottom: 15px;

  @media (max-width: 768px) {
    margin-top: 10px;
    font-size: 10px;
  }
}

@media (max-width: 768px) {
  .footer .wrapper {
    flex-direction: column;
  }

  .footer {
    padding: 32px 16px;
  }

  .footer .wrapper .center {
    text-align: left;
  }
}
</style>
